(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_370a9e7"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('a, button').forEach(function(el) {
      const text = el.textContent.trim().toLowerCase();
      
      if (text.includes('compare')) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          document.getElementById('colorways')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      
      if (text.includes('shop')) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          document.getElementById('product-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_7b615fa"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('a, button, [role="button"], div[class*="card"]').forEach(function(el) {
      const text = el.textContent.trim().toLowerCase();
      if (text.includes('washed black') || text.includes('vintage indigo') || text.includes('stonewash')) {
        el.style.cursor = 'pointer';
        el.addEventListener('click', function(e) {
          e.preventDefault();
          document.getElementById('product-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
